import React, { useContext } from 'react';

import { TransferAccountsState, useTransferFromAndToAccount } from '../../../../hooks/useAccountState';
import { FormContext, useForm, Form, CreateForm } from '../../../../hooks/useForm';
import { TransferAction, TransferActionType } from './actions';
import { TransferState } from './state';
import { TransferError } from './validate';

export default () => {
    const context = useContext(FormContext)! as Form<TransferState, TransferAction, TransferError, TransferActionType>;
    if (context === undefined) {
        throw new Error('useFormContext must be used within FormContext');
    }

    return context;
};

export const TransferFormContext = ({
    validateHook,
    reducer,
    initialState,
    children,
}: CreateForm<TransferState, TransferAction, TransferError>) => {
    const form = useForm(validateHook, reducer, initialState);
    const transferAccountState = useTransferFromAndToAccount(form.state.fromAccount, form.state.toAccount);
    return (
        <FormContext.Provider value={form}>
            <TransferAccountsState.Provider value={transferAccountState}>{children}</TransferAccountsState.Provider>
        </FormContext.Provider>
    );
};
